<template>
  <div class="show-more-less cursor-pointer row" @click="$emit('input', !value)">
    <div class="text-lowercase-btn text-grey3">
      {{ value ? 'see less' : 'see more' }}
    </div>
    <TriangleIcon :class="{ 'rotate-180': value }" />
  </div>
</template>

<script>
// Libraries
// Components
import TriangleIcon from '@/ui/icons/TriangleIcon'

export default {
  components: {
    TriangleIcon
  },

  props: {
    value: Boolean
  }
}
</script>

<style lang="scss" scoped>
.show-more-less {
}
</style>
